import { SubscriptionItemType } from '../common/interfaces';

/**
 * Check if a subscription is recurring means it automatically renews every month
 * @param itemType
 * @returns boolean
 */
export var isSubscriptionRecurring = function isSubscriptionRecurring(itemType) {
  return itemType === SubscriptionItemType.FIXED_RECURRING_ITEM || itemType === SubscriptionItemType.RECURRING_BUNDLE_ITEM || itemType === SubscriptionItemType.SUBSCRIPTION;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/isSubscriptionRecurring.js
// module id = 4127
// module chunks = 11